import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ChecklistPage } from './checklist';
import { ChecklistPhonePage } from './Phone/ChecklistPhonePage';
import { ZusatzinformationenPhonePage } from './Phone/ZusatzinformationenPhonePage';
import { ComponentsModule } from "../../components/components.module"

@NgModule({
	declarations: [
		ChecklistPage,
		ChecklistPhonePage,
		ZusatzinformationenPhonePage
	],
	imports: [
		IonicPageModule.forChild(ChecklistPage),
		IonicPageModule.forChild(ChecklistPhonePage),
		IonicPageModule.forChild(ZusatzinformationenPhonePage),
		ComponentsModule
  ],
})
export class ChecklistPageModule {}



// WEBPACK FOOTER //
// ./src/pages/checklist/checklist.module.ts